import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectChatState, selectUiState, selectVideoCall } from '../../../../store/app.selectors';

import { MessagingEnvironmentService } from '../../../../core/services/messaging-environment.service';
import { BaseComponent } from '../../../shared/components/base/base.component';
import { uiInitialState } from '../../../shared/store/ui.reducer';
import { Suggestion } from '../../interfaces/IMessage';
import { ChannelsService } from '../../services/channels.service';
import { SmartRepliesService } from '../../services/smart-replies.service';
import { MessagingTranslationService } from '../../services/translations.service';
import { AppStateWithChat, chatInitialState } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-channel',
  templateUrl: './channel.component.html',
  styleUrls: ['./channel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChannelComponent extends BaseComponent implements OnInit {
  @Input() view: string;
  @Output() linkClicked = new EventEmitter<boolean>();
  @Output() orderIdEvent = new EventEmitter<string>();
  @ViewChild('chatBody') chatBodyElement: ElementRef;

  private store = inject(Store<AppStateWithChat>);
  public translationService = inject(MessagingTranslationService);
  private env = inject(MessagingEnvironmentService);
  public smartRepliesService = inject(SmartRepliesService);
  private channelsService = inject(ChannelsService);

  ui = toSignal(this.store.select(selectUiState), { initialValue: uiInitialState });
  chat = toSignal(this.store.select(selectChatState), { initialValue: chatInitialState });
  videoCall = toSignal(this.store.select(selectVideoCall), { initialValue: null });

  url = computed(() => {
    const selectedChannel = this.chat().selectedChannel;
    const selectedWorkSpace = this.chat().selectedWorkSpace;
    if (!selectedChannel || !selectedWorkSpace) {
      return '';
    }
    return this.channelsService.createChannelUrl(
      selectedChannel,
      selectedWorkSpace,
      this.env.env.urlMesaging,
      this.env.env.hideURLToken ?? false
    );
  });

  smartReplies: Suggestion[] = [];
  isMobile: boolean;
  appVersion: string;
  hideConversation: boolean;

  ngOnInit() {
    this.appVersion = this.env.env.libraryVersion;
    this.hideConversation = this.view === 'input';
  }

  showInputSection(): boolean {
    if (this.view === 'conversation') {
      return false;
    }
    return !this.ui().hideInputChat;
  }

  handleLinkClick(data: boolean) {
    this.linkClicked.emit(data);
  }

  emitOrderIdEvent(event: string): void {
    this.orderIdEvent.emit(event);
  }
}
